module.exports = __webpack_public_path__ + "img/281aed6.webp";